import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { RouterOutlet, RouterModule } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { CommonService } from '../../../Model/Common/common.service';
import { LetterDocumentService } from '../../../Model/LetterDocument/letter-document.service';
import { LetterDocumentTypeFormComponent } from '../../LetterDocumentType/letter-document-type-form/letter-document-type-form.component';
import { LetterTemplateFormComponent } from '../letter-template-form/letter-template-form.component';

@Component({
  selector: 'app-letter-template',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule, DataTablesModule, LoaderComponent],
  templateUrl: './letter-template.component.html',
  styleUrl: './letter-template.component.scss'
})
export class LetterTemplateComponent {
  isDisabled: boolean = false;
  TableDatas: any[] = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private modalService: NgbModal,
    protected common: CommonService,
    private letterDocument: LetterDocumentService
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ESSLetterTemplateMasterSelect();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  addLetterTemplate(ID: any) {
    if ((this.common.PageRight.IsAdd && ID == 0) || (this.common.PageRight.IsEdit && ID > 0)) {
      const modalRef = this.modalService.open(LetterTemplateFormComponent);
      modalRef.componentInstance.ID = ID;
      modalRef.result.then(
        (result: any) => {
          if (result) {
            this.ESSLetterTemplateMasterSelect();
          }
        },
        () => { }
      );
    }
  }

  ESSLetterTemplateMasterSelect() {
    this.isDisabled = true;
    this.letterDocument.ESSLetterTemplateMasterSelect({ ESS_LetterTemplateMasterID: 0, SelectType: 1 }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.TableDatas = Object.values(response.Table);
        } else {
          this.TableDatas = Object.values([]);
        }
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
}
